


























import {Component, Vue} from 'vue-property-decorator'
import { Action } from 'vuex-class'
import AuthRequest from '../../model/request/AuthRequest'
import * as Helper from '@/helpers/'
import AuthResponse from '@/model/response/AuthResponse'
import Responsavel from '@/model/resource/Responsavel'
import {IResource, ObjectCollection} from 'simpli-web-sdk'

@Component
export default class SignInFilialView extends Vue {
  @Action('auth/validateFilial') validateFilial!: Function

  request = new AuthRequest()

  listaFiliaisResponsavelResource: IResource[] = []
  selectedFilialResource: IResource | null  = null

  async mounted() {
    const userDataString = localStorage.getItem('ud')

    const userData = userDataString ? JSON.parse(userDataString) : null

    this.request.cnpj = this.$route.params.user || (userData && userData.u)
    this.request.senha = this.$route.params.password || (userData && userData.up)

    if (!this.request.cnpj || !this.request.senha) {
      this.$router.push('/sign-in')
      return
    }

    const {data} = await AuthResponse.listResponsavelFilial(this.request)

    data.forEach((item: Responsavel) => {
      item.$tag = `${item.nomeFantasia || item.razaoSocial} - ${Helper.cnpj(item.cnpj)}`
    })

    this.listaFiliaisResponsavelResource = new ObjectCollection(data)
        .prependNull('view.signInFilial.inputPlaceholder').items

    if (this.listaFiliaisResponsavelResource.length === 1) {
      this.selectedFilialResource = this.listaFiliaisResponsavelResource[0]
      await this.handleSubmit()
    }

    this.$await.done('loadingData')
  }

  async handleSubmit() {
    if (!this.hasSelectedFilial) {
      Helper.abort('view.signInFilial.errorNoResponsavel')
      return
    }
    this.request.idResponsavel = this.selectedFilialResource && this.selectedFilialResource.$id as number
    await this.validateFilial(this.request)
  }

  get hasSelectedFilial() {
    return !!(this.selectedFilialResource && this.selectedFilialResource.$id)
  }
}
